module.exports = __webpack_public_path__ + "img/Orders Icon - white.59fb1db2.svg";